import { SchemaPlugin } from '@common/prosemirror/model/schema-plugin';
import { getSchemaAttrs, nodeToDOM } from '@common/util/schema';
import { NodeSpec } from 'prosemirror-model';

export class MadCapConceptSchemaPlugin extends SchemaPlugin {
  nodes = {
    madcapconcept: {
      group: 'inline',
      inline: true,
      attrs: {
        term: { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:concept',
        getAttrs(dom) {
          return getSchemaAttrs(dom, ['term']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:concept',
      isTagNameBox: true,
      isVoid: true
    },

    madcapconceptlink: {
      group: 'inline',
      inline: true,
      isLink: true,
      attrs: {
        term: { default: undefined }
      },
      parseDOM: [{
        tag: 'MadCap\\:conceptLink',
        getAttrs(dom) {
          return getSchemaAttrs(dom, ['term']);
        }
      }],
      toDOM(node) { return nodeToDOM(node); },
      tagName: 'MadCap:conceptLink',
      isTagNameBox: true,
      isVoid: true
    }
  } satisfies Record<string, NodeSpec>;
}
